import { css } from '@emotion/css';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/features';
import { actions } from 'src/features/user';
import { LoadingFailed } from './shared/LoadingFailed';

/*
 NOTE: このコンポーネントはiOSでしばらく経ってからCoralをresumeした際に
 JavaScriptの実行環境が初期化されてしまった場合に表示するエラー表示
https://mcat.marioclub.co.jp/#/project/1149/box/15212/list/816
 */
export const RestartRequired: React.FC = () => {
  const { language } = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    // NOTE: na_countryはBlanco起動時にURLのクエリパラメータで渡される値。
    // その値をSession Storageに保持して使用する。
    const country = window.sessionStorage.getItem('na_country') ?? '';
    dispatch(actions.setupLanguage({ language: navigator.language, country }));
  }, [dispatch]);

  return (
    <div
      className={css`
        margin-top: 52px;
      `}
    >
      {language ? <LoadingFailed error="restart-required" /> : null}
    </div>
  );
};
